import ApiEndPoints from 'utils'
import { notification } from 'antd'
import apiClient from '../index'

export const addHierarchy = (data) => apiClient.post('/hierarchy', data)

export const getHierarchy = (skip, limit) =>
  apiClient.get('/hierarchy', {
    params: {
      skip,
      limit,
    },
  })

export const editHierarchy = async (data, id) => {
  try {
    return await apiClient.patch(`${ApiEndPoints.UPDATE_HIERARCHY}/${id}`, data)
  } catch (error) {
    if (error?.response?.data?.statusCode) {
      notification.error({
        message: 'Error',
        description: error?.response?.data?.message,
      })
    }
    return null
  }
}
